import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { ChevronLeft } from '@mui/icons-material';

const AnimatedSidebarIcon = () => {
  return (
        <Tooltip title="Click for more details">
        <IconButton
          className='hoverBox'
          onClick={() => null}
          sx={theme => ({
            transition: theme.transitions.create(['background-color', 'transform'], {
              duration: 300,
            }),
          })}
        >
        <ChevronLeft className='slide-icon' />
      </IconButton>
      </Tooltip>
  );
};
export default AnimatedSidebarIcon;